$.fn.extend({
    animateCss: function(animationName) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        $(this).addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName);
        });
    }
});

$(".card-btn-toggle").on("click", function() {
    $('[data-target="' + $(this).data("target") + '"]').children("i").toggleClass("fa-plus-square fa-minus-square");
});

$('.cardboard').each(function() {
    var timeout = 150;
    $(this).find(".card").each(function(index, card) {
        $(card).hide();
        setTimeout(function() {
            $(card).show();
            $(card).animateCss("fadeInDown");
        }, timeout * index);
    });
});
